import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import classNames from "classnames";
import { Avatar, FloatButton, Spin } from "antd";
import Loader from "../components/common/loader";
import BreadCrumbs from "./breadcrumbs/BreadCrumbs";
import { useSelector } from "react-redux";
import _ from "lodash";

function AdminPageLayout({
  children,
  loading,
  isBreadCrumbs = true,
  isButton = false,
  isLinkButton = false,
  buttonAction,
  buttonTitle = "",
  buttonLinkUrl = "",
  btnClass,
  extraContent,
  extraContentBefor,
  isPadding = true,
  isCardView = true,
  isViewhelpBtn = true,
  marqueeHeading
}) {

  const navigate = useNavigate()
  const { user: currentUser } = useSelector((state) => state.user);

  return (
    <Spin spinning={loading} indicator={<Loader />}>
      <div className="">
        {marqueeHeading && marqueeHeading}
        <Row className="mb-2 align-items-center">
          {isBreadCrumbs && <Col md={isButton ? "6" : "12"}>
            <BreadCrumbs />
          </Col>}
          {isButton && (
            <Col md="6" className="text-end">
              {extraContentBefor && extraContentBefor}
              {isLinkButton ? (
                <Link to={buttonLinkUrl}>
                  <Button className={classNames("btn", btnClass || 'btn-tab')}>
                    {buttonTitle}
                  </Button>
                </Link>
              ) : (
                <Button
                  className={classNames("btn", btnClass || 'btn-tab')}
                  onClick={buttonAction}
                >
                  {buttonTitle}
                </Button>
              )}
              {extraContent && extraContent}
            </Col>
          )}
        </Row>
        <Row>
          <Col lg="12">
            {isCardView ? <Card>
              <CardBody style={{ padding: isPadding ? "10px" : "0px" }}>
                {children}
              </CardBody>
            </Card> : <div className={classNames(isPadding ? "p-2" : 'p-0')}>
              {children}
            </div>}
          </Col>
        </Row>
      </div>

      {isViewhelpBtn && !_.isEmpty(currentUser) && _.toNumber(currentUser.role) === 1 ? (
        <FloatButton.Group
          trigger="click"
          type="primary"
          size='large'
          style={{
            // insetInlineEnd: "5%",
            width: "250px",
            bottom: '5%',
            right: '3%',
            display:"flex",
            alignItems:"end"
          }}
          icon={<i className="bi bi-headset fs-2" />}
          className="customer-support-menu"
          tooltip="Customer Support"
        >
          <div className="bg-white rounded-2 complaint-menu-body">
            <div className="bg-primary text-light rounded-top p-2">
              <i className="bi bi-headset fs-3 me-1" />{" "}
              <span className="fs-4 fw-bold">Customer Support</span>
            </div>
            <div className="text-end px-2 bg-white">
              <div onClick={() => navigate('/helpDesk/complaintList')} className="py-2 px-2 border border-1 border-top-0 border-start-0 border-end-0">
                <div className="d-flex justify-content-end align-items-center mb-0">
                  <span className="fs-4 fw-bold me-2">Track Complaint</span>{" "}
                  <Avatar
                    style={{
                      backgroundColor: "#745af2",
                    }}
                    icon={<i className="bi bi-headset fs-3" />}
                  />
                </div>
                <p className="fs-6">Check Status on existing tickets</p>
              </div>
              <div onClick={() => navigate('/helpDesk/newComplaint')} className="py-2 px-2 border border-1 border-top-0 border-start-0 border-end-0">
                <div className="d-flex justify-content-end align-items-center mb-0">
                  <span className="fs-4 fw-bold me-2">Raise a Ticket</span>{" "}
                  <Avatar
                    style={{
                      backgroundColor: "#745af2",
                    }}
                    icon={<i className="bi bi-headset fs-3" />}
                  />
                </div>
                <p>Have a query? Raise it with us.</p>
              </div>
              <div className="py-2 px-2">
                <div className="d-flex justify-content-end align-items-center mb-0">
                  <span className="fs-4 fw-bold me-2">Call Us</span>{" "}
                  <Avatar
                    style={{
                      backgroundColor: "#745af2",
                    }}
                    icon={<i className="bi bi-headset fs-3" />}
                  />
                </div>
                <p>Get quick support</p>
              </div>
            </div>
            <div className="bg-warning bg-opacity-75 text-light text-center rounded-bottom p-1">
              <i className="bi bi-wechat fs-3 me-1" />{" "}
              <span className="fs-5 fw-bold">FAQ</span>
            </div>
          </div>
        </FloatButton.Group>
      ) : (
        ""
      )}
    </Spin>
  );
}

export default AdminPageLayout;
